import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { I18nResources, useI18n } from '@app-velocity/i18n';

import { Typography } from '../../../Typography';

export type StickyHeaderProps = {
  title: I18nResources;
  right?: ReactNode;
};

const StyledHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  backgroundColor: 'var(--background-background-color)',
  position: 'sticky',
  zIndex: 2,
  left: 0,
  top: 0,
  padding: theme.spacing(4),
}));

const StyledTitle = styled(Typography)({
  fontSize: 16,
});

export const StickyHeader = ({ title, right }: StickyHeaderProps) => {
  const { t } = useI18n();

  return (
    <StyledHeader>
      <StyledTitle variant="header" component="h2">
        {t(title)}
      </StyledTitle>
      {right ? right : null}
    </StyledHeader>
  );
};
